const Data = [
  {
    id: 'ObraGris',
    name: 'Gris',
    quote_text: 'Apartamento en Obra Gris',
    price: '0',
    featureId: '4f1dc27b-db77-472e-bfcd-0808b60bcd6a',
    startingPlace: "Obragris_Sala",
  },
  {
    id: 'Básico',
    name: 'Mono',
    quote_text: 'Apartamento Mono',
    price: '0',
    featureId: '',
    startingPlace: "Tipo1_Cocina",
  },
  {
    id: 'Liviano',
    name: 'Liviano',
    quote_text: 'Apartamento Liviano',
    price: '26,000,000',
    featureId: 'ed2f01b7-0a92-4e6d-903a-f08329bee5f8',
    startingPlace: "Mezanine_Sala",
  },
]

module.exports = { Data };